<template>
  <!-- _________________________ FORGOT PASSWORD _________________________ -->
  <div id="forgot-password-div">

    <h1 class="page-title login-title mt-4">
      {{ $t('forgotTitle') }}
    </h1>
    <h2 class="secondary-page-title mt-2">
      {{ $t('forgotSubtitle') }}
    </h2>

    <form @submit.stop.prevent="handleForgotSubmit" class="mt-4">

      <b-alert :show="ui.showError" variant="danger">
        {{ ui.showErrorMessage  }}
        <a href="#" v-on:click="resendValidateAccountMail" v-if="ui.showValidateAccountError">
          {{$t('account.not.validated.resent.error')}}
        </a>
      </b-alert>

      <b-alert :show="ui.showResendValidateAccountMailSuccess" variant="success">
        {{ $t('ResendValidateAccountMail.success') }}
      </b-alert>

      <b-alert :show="ui.showForgotSuccess" variant="success">
        {{ $t('Forgot.success') }}
      </b-alert>

      <b-form-group
        :label="$t('forgotCredential')"
        label-for="username-input">
        <b-form-input
          id="username-input"
          v-model="form.username.value"
          type="email"
          required
          @keydown="hideMessages">
        </b-form-input>
      </b-form-group>

      <div class="mt-4">
        <b-button type="submit" class="btn-block" variant="primary">{{ $t('forgotButtonText') }}</b-button>
      </div>

    </form>

    <div class="mt-4 text-right">
      <b-link v-on:click="showLoginView" class="forgot-password-link textual-link">{{ $t('backToLoginText') }}</b-link>
    </div>
  </div>
</template>

<script>

import api from '../../../services/api'

export default {

  name: 'ForgotPasswordComponent',

  data () {
    return {
      form: {
        username: {
          value: null
        }
      },
      ui: {
        showError: false,
        showErrorMessage: this.$i18n.t('internal.server.error'),
        showValidateAccountError: false,
        showResendValidateAccountMailSuccess: false,
        showForgotSuccess: false
      }
    }
  },

  emits: ['showLoginView'],

  mounted () {
  },

  methods: {

    handleForgotSubmit () {
      this.hideError()

      let formData = new FormData()
      formData.append('username', this.form.username.value.trim())

      api({
        method: 'POST',
        url: `/forgotPassword/sendResetPasswordMail`,
        data: formData
      })
        .then(() => {
          this.ui.showForgotSuccess = true
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.ui.showErrorMessage = this.$i18n.t('Login.error')
            this.ui.showError = true
          }
          if (error.response.status === 403) {
            this.ui.showErrorMessage = this.$i18n.t(error.response.data.message)
            this.ui.showError = true
            if (error.response.data.message === 'account.not.validated.error') {
              this.ui.showValidateAccountError = true
            }
          }
          if (error.response.status === 423) {
            this.ui.showErrorMessage = this.$i18n.t('account.locked.error')
            this.ui.showError = true
          }
        })
    },

    resendValidateAccountMail () {
      this.hideError()

      let formData = new FormData()
      formData.append('username', this.form.username.value.trim())

      api({
        method: 'POST',
        url: `/authentication/resendValidateAccountMail`,
        data: formData
      })
        .then(() => {
          this.ui.showResendValidateAccountMailSuccess = true
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.ui.showErrorMessage = this.$i18n.t('Login.error')
            this.ui.showError = true
          }
          if (error.response.status === 500) {
            this.ui.showErrorMessage = this.$i18n.t('internal.server.error')
            this.ui.showError = true
          }
        })
    },

    showLoginView () {
      this.$emit('showLoginView')
    },

    hideError () {
      this.ui.showError = false
      this.ui.showErrorMessage = null
      this.ui.showValidateAccountError = false
    },

    hideMessages () {
      this.ui.showResendValidateAccountMailSuccess = false
      this.ui.showForgotSuccess = false
      this.hideError()
    }

  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/auth/components/ForgotPasswordComponent.vue